import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '../../components/api/ApiClient';

function Login() {
    const navigate = useNavigate();
    const [view, setView] = useState('LOGIN');
    const [loading, setLoading] = useState(false);
    const [timer, setTimer] = useState(0);
    const [formData, setFormData] = useState({
        username: '',
        password: '',
        mobile: '',
        otp: '',
        newUserName: '',
        newPassword: '',
        rePassword: ''
    });
    const [toast, setToast] = useState({ show: false, message: '' });
    const [showPassword, setShowPassword] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);

    useEffect(() => {
        let interval = null;
        if (timer > 0) {
            interval = setInterval(() => setTimer((t) => t - 1), 1000);
        } else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [timer]);

    useEffect(() => {
        const token = localStorage.getItem('access_token');
        if (token) {
            navigate('/dashboard/');
        }
    }, []);

    useEffect(() => {
        if (toast.show) {
            const timer = setTimeout(() => setToast({ ...toast, show: false }), 5000);
            return () => clearTimeout(timer);
        }
    }, [toast.show]);

    const showToast = (message) => {
        setToast({ show: true, message });
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        console.log('Login attempt:', { username: formData.username, rememberMe });
        setLoading(true);
        try {
            const data = await apiClient('/account/api/login/', {
                method: 'POST',
                data: { username: formData.username, password: formData.password }
            });
            if (data && data.access) {
                localStorage.setItem('access_token', data.access);
                localStorage.setItem('refresh_token', data.refresh);
                localStorage.setItem('user_data', JSON.stringify({
                    username: data.username,
                    company: data.company_name,
                    first_name: data.first_name || '',
                    last_name: data.last_name || ''
                }));
                navigate('/dashboard/');
            }
        } catch (error) {
            console.error(error);
            showToast(error.message || 'خطا در ورود به سیستم');
        } finally {
            setLoading(false);
        }
    };

    const handleSendOtp = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await apiClient(`/account/api/OtpHandler/?phonenumber=${formData.mobile}&state=register&register=true`, { method: 'GET' });
            setTimer(120);
            setView('REGISTER_OTP');
        } catch (error) {
            console.error(error);
            showToast('خطا در ارسال کد تایید. لطفا شماره را بررسی کنید.');
        } finally {
            setLoading(false);
        }
    };

    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await apiClient('/account/api/OtpHandler/', {
                method: 'POST',
                data: { otp: formData.otp, phoneNumber: formData.mobile }
            });
            setView('REGISTER_DETAILS');
        } catch (error) {
            console.error(error);
            showToast('کد وارد شده صحیح نیست.');
        } finally {
            setLoading(false);
        }
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        if (formData.newPassword !== formData.rePassword) {
            showToast('رمز عبور و تکرار آن مطابقت ندارند.');
            return;
        }
        setLoading(true);
        try {
            const data = await apiClient('/account/api/register/', {
                method: 'POST',
                data: {
                    userName: formData.newUserName,
                    newpassword: formData.newPassword,
                    rePassword: formData.rePassword,
                    phoneNum: formData.mobile,
                }
            });
            if (data.message === 'All fields are required') {
                showToast('لطفا تمامی فیلد هارا پر کنید.');
            } else if (data.message === 'exist') {
                showToast('نام کاربری یا شماره تلفن درحال حاضر وجود دارد.');
            } else if (data.message === 'password must be the same') {
                showToast('رمز عبور و تکرار رمز عبور باهم تطابق ندارد.');
            }
            else if (data.access) {
                localStorage.setItem('access_token', data.access);
                localStorage.setItem('refresh_token', data.refresh);
                showToast('ثبت نام با موفقیت انجام شد.');
                window.location.href = '/dashboard/';
            } else {
                showToast('ثبت نام انجام شد اما اطلاعات ورود دریافت نشد. لطفا وارد شوید.');
                setView('LOGIN');
            }
        } catch (error) {
            console.error(error);
            showToast('خطا در ثبت نام.');
        } finally {
            setLoading(false);
        }
    };

    const renderLogin = () => (
        <form onSubmit={handleLogin} className="w-100 mt-4 pt-2">
            <h2 className="fs-20 fw-bolder mb-4 text-center">به اکوسیستم آرسین خوش آمدید</h2>
            <h4 className="fs-13 fw-bold mb-2 text-center">لطفا برای ورود نام کاربری و رمز عبور خود را وارد کنید</h4>
            <div className="mb-4 mt-5">
                <input
                    name="username"
                    className="form-control"
                    placeholder="نام کاربری"
                    value={formData.username}
                    onChange={handleChange}
                    required
                />
            </div>
            <div className="mb-3 position-relative">
                <input
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    className="form-control"
                    placeholder="رمز عبور"
                    value={formData.password}
                    onChange={handleChange}
                    required
                />
                <i
                    className={`feather-eye${showPassword ? '-off' : ''}`}
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '10px',
                        transform: 'translateY(-50%)',
                        cursor: 'pointer',
                        zIndex: 10,
                        color: '#6c757d'
                    }}
                    onClick={() => setShowPassword(!showPassword)}
                />
            </div>
            <div className="mb-3">
                <div className="d-flex align-items-center justify-content-between">
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="rememberMe"
                            checked={rememberMe}
                            onChange={(e) => setRememberMe(e.target.checked)}
                        />
                        <label className="form-check-label ms-2" htmlFor="rememberMe">
                            مرا به خاطر بسپار
                        </label>
                    </div>
                    <a href="/forget-password/" onClick={(e) => { e.preventDefault(); navigate('/forget-password/'); }} className="fw-bold fs-12 text-primary">
                        فراموشی رمز عبور؟
                    </a>
                </div>
            </div>
            <button disabled={loading} type="submit" className="btn btn-lg btn-primary w-100 mb-3">
                {loading ? '...' : 'ورود'}
            </button>
            <div className="text-center">
                <span>حساب کاربری ندارید؟ </span>
                <span className="fw-bold text-primary cursor-pointer" style={{ cursor: 'pointer' }} onClick={() => setView('REGISTER_MOBILE')}>
                    ایجاد حساب کاربری
                </span>
            </div>
        </form>
    );

    const renderRegisterMobile = () => (
        <form onSubmit={handleSendOtp} className="w-100 mt-4 pt-2">
            <h2 className="fs-20 fw-bolder mb-4">ثبت نام</h2>
            <h4 className="fs-13 fw-bold mb-2">شماره موبایل خود را وارد کنید</h4>
            <div className="mb-4">
                <input
                    name="mobile"
                    className="form-control"
                    placeholder="شماره موبایل (مثلا 0912...)"
                    value={formData.mobile}
                    onChange={handleChange}
                    required
                />
            </div>
            <button disabled={loading} type="submit" className="btn btn-lg btn-primary w-100 mb-3">
                {loading ? '...' : 'ارسال کد تایید'}
            </button>
            <div className="text-center">
                <span className="fw-bold text-secondary cursor-pointer" style={{ cursor: 'pointer' }} onClick={() => setView('LOGIN')}>
                    بازگشت به ورود
                </span>
            </div>
        </form>
    );

    const renderRegisterOtp = () => (
        <form onSubmit={handleVerifyOtp} className="w-100 mt-4 pt-2">
            <h2 className="fs-20 fw-bolder mb-4">تایید شماره</h2>
            <h4 className="fs-13 fw-bold mb-2">کد ارسال شده به {formData.mobile} را وارد کنید</h4>
            <div className="mb-4">
                <input
                    name="otp"
                    className="form-control text-center letter-spacing-5"
                    placeholder="xxxxx"
                    value={formData.otp}
                    onChange={handleChange}
                    maxLength={5}
                    required
                />
            </div>
            <div className="mb-3 text-center">
                {timer > 0 ? (
                    <span className="text-muted">{Math.floor(timer / 60)}:{('0' + timer % 60).slice(-2)} تا ارسال مجدد</span>
                ) : (
                    <span className="text-primary cursor-pointer" style={{ cursor: 'pointer' }} onClick={handleSendOtp}>
                        ارسال مجدد کد
                    </span>
                )}
            </div>
            <button disabled={loading} type="submit" className="btn btn-lg btn-primary w-100 mb-3">
                {loading ? '...' : 'تایید کد'}
            </button>
            <div className="text-center">
                <span className="fw-bold text-secondary cursor-pointer" style={{ cursor: 'pointer' }} onClick={() => setView('REGISTER_MOBILE')}>
                    تغییر شماره
                </span>
            </div>
        </form>
    );

    const renderRegisterDetails = () => (
        <form onSubmit={handleRegister} className="w-100 mt-4 pt-2">
            <h2 className="fs-20 fw-bolder mb-4">تکمیل ثبت نام</h2>
            <div className="mb-3">
                <label className="form-label">شماره موبایل</label>
                <input className="form-control" value={formData.mobile} disabled />
            </div>
            <div className="mb-3">
                <label className="form-label">نام کاربری</label>
                <input
                    name="newUserName"
                    className="form-control"
                    value={formData.newUserName}
                    onChange={handleChange}
                    required
                />
            </div>
            <div className="mb-3">
                <label className="form-label">رمز عبور</label>
                <input
                    name="newPassword"
                    type="password"
                    className="form-control"
                    value={formData.newPassword}
                    onChange={handleChange}
                    required
                />
            </div>
            <div className="mb-4">
                <label className="form-label">تکرار رمز عبور</label>
                <input
                    name="rePassword"
                    type="password"
                    className="form-control"
                    value={formData.rePassword}
                    onChange={handleChange}
                    required
                />
            </div>
            <button disabled={loading} type="submit" className="btn btn-lg btn-success w-100 mb-3">
                {loading ? '...' : 'ثبت نام نهایی'}
            </button>
        </form>
    );

    return (
        <main className="auth-cover-wrapper position-relative">
            {toast.show && (
                <div aria-live="polite" aria-atomic="true" className="position-absolute w-100 p-3" style={{ zIndex: 9999, top: 0, right: 0 }}>
                    <div className="toast-container position-absolute p-3" id="toastPlacement" style={{ top: 0, left: 0 }}>
                        <div className="toast show" role="alert" aria-live="assertive" aria-atomic="true">
                            <div className="toast-header" style={{ direction: 'rtl' }}>
                                <img src="/assets/images/redesigned.png" className="rounded ms-2" alt="..." width="20" />
                                <strong className="me-auto ms-2">پیام سیستم</strong>
                            </div>
                            <div className="toast-body">
                                {toast.message}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className="auth-cover-sidebar-inner">
                <div className="auth-cover-card-wrapper">
                    <div className="auth-cover-card p-sm-5">
                        <div className="wd-50 mb-3">
                            <img src="/assets/images/logo-abbr.png" alt="" className="img-fluid" />
                        </div>

                        {view === 'LOGIN' && renderLogin()}
                        {view === 'REGISTER_MOBILE' && renderRegisterMobile()}
                        {view === 'REGISTER_OTP' && renderRegisterOtp()}
                        {view === 'REGISTER_DETAILS' && renderRegisterDetails()}

                    </div>
                </div>
                <button
                    type="button"
                    className="btn btn-outline-secondary d-flex align-items-center gap-2 position-absolute top-0 m-3"
                    onClick={() => navigate('/')}
                    style={{ zIndex: 10, fontSize: '0.85rem', borderRadius: '8px' }}
                >
                    <i className="feather-arrow-right" />
                    <span className="d-none d-sm-inline">بازگشت</span>
                </button>
            </div>
            <div className="auth-cover-content-inner">
                <div className="auth-cover-content-wrapper">
                    <div className="auth-img">
                        <img src="/assets/images/auth/auth-cover-login-bg.svg" alt="" className="img-fluid" />
                    </div>
                </div>
            </div>
        </main>
    );
}

export default Login;
